(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ask-box"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('faq-ask')) return;
    customElements.define(
      'faq-ask',
      class extends HTMLElement {
        connectedCallback() {
          const form = this.querySelector('[data-form]');
          const input = this.querySelector('[data-input]');
          const out = this.querySelector('[data-answer]');
          const tpl = (name) => this.querySelector(`[data-${name}]`)?.innerHTML || '';
          const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
          let last = '';
          form.addEventListener('submit', async (e) => {
            e.preventDefault();
            const q = input.value.trim();
            if (!q) return;
            last = q;
            out.hidden = false;
            out.className = 'faq__answer is-thinking';
            out.innerHTML = tpl('thinking');
            let r = null;
            try {
              r = window.HaldenAsk ? await window.HaldenAsk(q) : null;
            } catch (err) {}
            out.className = 'faq__answer';
            void out.offsetWidth;
            if (r && r.a && r.intent) {
              out.innerHTML = `${esc(r.a)} <button type="button" class="faq__handoff" data-intent="${esc(r.intent)}">${esc(r.l || '')}</button>`;
            } else if (r && r.a) {
              out.innerHTML = esc(r.a) + (r.u ? ` <a href="${esc(r.u)}">${r.l ? esc(r.l) : tpl('more')}</a>` : '');
            } else {
              out.innerHTML = tpl('unsure');
            }
          });
          this.addEventListener('click', (e) => {
            if (e.target.closest('[data-handoff]')) document.dispatchEvent(new CustomEvent('help:open', { detail: { ask: last } }));
            const go = e.target.closest('[data-intent]');
            if (go) document.dispatchEvent(new CustomEvent('help:open', { detail: { intent: go.dataset.intent } }));
          });
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halden-product-switch"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('product-switch')) return;
    /* go to the chosen product: a full page load keeps every part of the product page working
       (gallery, express checkout, tabs); browsers that support it crossfade between the pages */
    const swap = (url) => {
      document.querySelector('[id^="shopify-section-"][id*="__main"]')?.setAttribute('data-switching', '');
      location.href = url;
    };
    customElements.define(
      'product-switch',
      class extends HTMLElement {
        connectedCallback() {
          if (!history.state) history.replaceState({ productSwitch: this.dataset.section }, '', location.href);
          this.addEventListener('click', (e) => {
            const a = e.target.closest('a.pswitch__item');
            if (!a || a.classList.contains('is-on') || e.metaKey || e.ctrlKey || e.shiftKey) {
              if (a?.classList.contains('is-on')) e.preventDefault();
              return;
            }
            e.preventDefault();
            swap(a.href, this.dataset.section, true);
          });
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mascot-accent"] && !Shopify.designMode) return;
  try {
    /* mascot eyes follow the pointer (phones: they glance around) */
  (() => {
    if (window.__macEyes || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.__macEyes = true;
    let px = null, py = null, last = 0, glance = { x: 0, y: 0 }, next = 0;
    addEventListener('pointermove', (e) => { px = e.clientX; py = e.clientY; last = performance.now(); }, { passive: true });
    const tick = (now) => {
      requestAnimationFrame(tick);
      const eyes = document.querySelectorAll('.mac__eye');
      if (!eyes.length) return;
      if (now > next) { const a = Math.random() * 6.28; glance = { x: Math.cos(a) * 0.8, y: Math.sin(a) * 0.5 }; next = now + 1500 + Math.random() * 2000; }
      eyes.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        let x = glance.x, y = glance.y;
        if (px !== null && now - last < 3000) {
          const dx = px - (r.left + r.width / 2), dy = py - (r.top + r.height / 2), d = Math.max(1, Math.hypot(dx, dy)), k = Math.min(1, d / 200);
          x = (dx / d) * k; y = (dy / d) * k;
        }
        el.style.setProperty('--ex', x.toFixed(3));
        el.style.setProperty('--ey', y.toFixed(3));
      });
    };
    requestAnimationFrame(tick);
  })();

  (() => {
    if (customElements.get('mascot-accent')) return;
    customElements.define(
      'mascot-accent',
      class extends HTMLElement {
        connectedCallback() {
          const io = new IntersectionObserver(
            ([e]) => {
              if (!e.isIntersecting) return;
              this.classList.add('is-in');
              setTimeout(() => this.classList.add('is-float'), 1200);
              io.disconnect();
            },
            { threshold: 0.3 }
          );
          io.observe(this);
          this.querySelector('.mac__body')?.addEventListener('click', () => {
            this.classList.remove('is-hop');
            void this.offsetWidth;
            this.classList.add('is-hop');
            setTimeout(() => this.classList.remove('is-hop'), 650);
          });
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["order-tracking-block"] && !Shopify.designMode) return;
  try {
    (() => {
    /* Need help? opens the Support assistant when the store has it on */
    document.querySelectorAll('[data-open-support]').forEach((btn) => {
      if (!document.querySelector('help-assistant')) return;
      btn.hidden = false;
      btn.addEventListener('click', () => document.dispatchEvent(new CustomEvent('help:open')));
    });

    if (customElements.get('order-tracking')) return;
    /* 17TRACK's script is fetched only after a visitor presses Track */
    let loading;
    const load = () =>
      (loading ||= new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = 'https://www.17track.net/externalcall.js';
        s.async = true;
        s.onload = () => (window.YQV5 ? resolve() : reject());
        s.onerror = reject;
        setTimeout(reject, 8000);
        document.head.appendChild(s);
      }).catch((err) => {
        loading = null;
        throw err;
      }));
    customElements.define(
      'order-tracking',
      class extends HTMLElement {
        connectedCallback() {
          this.form = this.querySelector('form');
          this.input = this.querySelector('input');
          this.status = this.querySelector('[data-status]');
          this.box = this.querySelector('.trk-lookup__result');
          this.form.addEventListener('submit', (e) => this.track(e));
          const n = new URLSearchParams(location.search).get('number');
          if (n) {
            this.input.value = n;
            this.form.requestSubmit();
          }
        }
        say(which, url) {
          this.status.hidden = !which;
          this.status.querySelector('[data-loading]').hidden = which !== 'loading';
          this.status.querySelector('[data-fallback]').hidden = which !== 'fallback';
          if (url) this.status.querySelector('[data-fallback-link]').href = url;
        }
        async track(e) {
          e.preventDefault();
          const n = this.input.value.trim().replace(/\s+/g, '');
          if (!n) return this.input.focus();
          const url = (this.dataset.url || 'https://t.17track.net/en#nums=[number]').replace('[number]', encodeURIComponent(n));
          if (this.dataset.mode !== 'inline') {
            window.open(url, '_blank', 'noopener');
            return this.say('fallback', url);
          }
          this.say('loading');
          try {
            await load();
            this.box.hidden = false;
            this.box.innerHTML = '';
            window.YQV5.trackSingle({ YQ_ContainerId: this.box.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: this.dataset.lang || 'en', YQ_Num: n });
            this.say(null);
            this.box.scrollIntoView({ behavior: 'smooth', block: 'start' });
          } catch (err) {
            this.box.hidden = true;
            window.open(url, '_blank', 'noopener');
            this.say('fallback', url);
          }
        }
      }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /* the sheet's photo follows the chosen color */
  document.addEventListener('change', (e) => {
    const photo = e.target.closest('.quick-sheet')?.querySelector('.quick-sheet__img');
    if (!photo || !e.target.dataset.photo) return;
    photo.removeAttribute('srcset');
    photo.src = e.target.dataset.photo;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gift-option"] && !Shopify.designMode) return;
  try {
    /* the message only travels with the item when "gift" is ticked */
  document.addEventListener('change', (e) => {
    const box = e.target.closest('.pb-giftopt__tick input');
    const msg = box?.closest('.pb-giftopt')?.querySelector('textarea');
    if (msg) msg.disabled = !box.checked;
  });
  } catch(e) { console.error(e); }
})();

})();
